import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import moment from 'moment-timezone';

import {
  fetchRecurringOrder,
  fetchActiveOrdersFromRecurringRule,
} from 'redux/modules/recurring-orders/effects';

import {
  getRecurringOrder,
  getRecurringOrderFetching,
  getActiveOrders,
  getActiveOrdersFetching,
} from 'redux/modules/recurring-orders/selectors';

import { CANCELLED } from 'modules/shipper-order/Form/constants';

import Loading from './Loading';
import OrderInfo from './OrderInfo';
import WeekDays from '../../WeekDays';

import { Flexer, Text, Tag, Spacer } from '@ontruck/orc';

import ShipperOrderFromRecurringTable from 'modules/recurring-orders/Detail/Content/OrderTable';

import { TitleStyled } from './styled';

const t = {
  repeats: 'Repeats:',
  edit: 'Edit configuration',
  rule: 'Every {days}',
  from_to: 'From {from} to {to}',
  cancelled: 'Cancelled',
};

class RODetailContent extends PureComponent {
  componentDidMount() {
    const { id, fetchRecurringOrder, fetchActiveOrdersFromRecurringRule } = this.props;

    fetchRecurringOrder({ id });
    fetchActiveOrdersFromRecurringRule({ id });
  }

  render() {
    const { loading, recurringOrder, id, activeOrders, loadingActiveOrders } = this.props;

    if (loading || !recurringOrder) {
      return <Loading />;
    }

    return (
      <div>
        <Flexer.Parent alignItems="flex-start" mBottom="L">
          <Flexer.Child flexBasis="420px" flexGrow="0">
            <div>{t.repeats}</div>
            <FormattedMessage
              id={`ro-${id}-rule`}
              defaultMessage={t.rule}
              values={{
                days: <WeekDays isoDays={recurringOrder.schedule} />,
              }}
            >
              {(text, days) => (
                <TitleStyled>
                  {text} {days}
                </TitleStyled>
              )}
            </FormattedMessage>
            <FormattedMessage
              id={`ro-${id}-rule`}
              defaultMessage={t.from_to}
              values={{
                from: moment(recurringOrder.start_from).format('MMM DD YYYY'),
                to: moment(recurringOrder.end_on).format('MMM DD YYYY'),
              }}
            >
              {(text) => <Text text={text} color="greyWolf" size="M" />}
            </FormattedMessage>
            {recurringOrder.rule_status === CANCELLED && (
              <Spacer mTop="S">
                <Tag skin="red" weight="bold" text={t.cancelled} />
              </Spacer>
            )}
          </Flexer.Child>
          <OrderInfo
            order={recurringOrder}
            shipper={recurringOrder.shipper}
            user={recurringOrder.user}
          />
        </Flexer.Parent>
        <Flexer.Parent alignItems="flex-start">
          <Flexer.Child flex={1}>
            <ShipperOrderFromRecurringTable
              recurringOrder={recurringOrder}
              activeOrders={activeOrders}
              loading={loadingActiveOrders}
            />
          </Flexer.Child>
        </Flexer.Parent>
      </div>
    );
  }
}

RODetailContent.propTypes = {
  id: PropTypes.string.isRequired,
  fetchRecurringOrder: PropTypes.func.isRequired,
  fetchActiveOrdersFromRecurringRule: PropTypes.func.isRequired,
  recurringOrder: PropTypes.shape({}),
  activeOrders: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  loadingActiveOrders: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  recurringOrder: getRecurringOrder(state),
  loading: getRecurringOrderFetching(state),
  activeOrders: getActiveOrders(state),
  loadingActiveOrders: getActiveOrdersFetching(state),
});

const mapDispatchToProps = {
  fetchRecurringOrder,
  fetchActiveOrdersFromRecurringRule,
};

export default connect(mapStateToProps, mapDispatchToProps)(RODetailContent);
